import React from "react";

import { Table, Tag, Button } from "antd";
import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";

import {
    baseUnitRender,
    categoryRender,
    deadlineAtRender,
    languageTypeRender,
    statusRender,
} from "../../../../table/fields/task";

import Settings from "../settings";

const Tasks = (props) => {
    const expandedRowRender = (record) => {
        const payables = record.payables.filter((e) => e.subtotalValue > 0);

        const columns = (props) => {
            const __columns = [
                { title: "", dataIndex: "", key: "1", width: 50 },
                {
                    title: "#",
                    dataIndex: "count",
                    key: "count",
                    align: "right",
                    width: 50,
                    render: (count) => Number.parseInt(count),
                },
                {
                    title: "Type",
                    dataIndex: "type",
                    key: "type",
                    width: 50,
                },
                { title: "%", dataIndex: "percent", key: "percent", align: "right", width: 50 },
                {
                    title: "Rate",
                    dataIndex: "rate_value",
                    key: "vendorRateValue",
                    align: "right",
                    width: 100,
                },
                {
                    title: "Subtotal",
                    dataIndex: "subtotal_value",
                    key: "vendorSubtotalValue",
                    align: "right",
                    width: 100,
                },
            ];

            return __columns;
        };

        return (
            <Table
                columns={columns(props)}
                rowKey={(record) => record.id}
                dataSource={payables || []}
                pagination={false}
                title={() => <Settings task={record} />}
            />
        );
    };
    const columns = (props) => {
        const __columns = [
            { title: "#", dataIndex: "code", key: "order", width: 50 },
            { title: "Service", dataIndex: "name", key: "name" },
            {
                title: "Category",
                dataIndex: "category",
                key: "category",
                render: categoryRender,
            },
            {
                title: "Language(s)",
                dataIndex: "language_type",
                key: "languageType",
                render: languageTypeRender,
            },
            {
                title: "Unit",
                dataIndex: "base_unit",
                key: "unit",
                render: baseUnitRender,
            },
            {
                title: "Vendor",
                dataIndex: "vendor",
                key: "vendor",
                render: (vendor) => {
                    if (vendor) {
                        return <>{vendor.name}</>;
                    }
                },
            },
            {
                title: "Rush Vendor",
                dataIndex: "rush_type",
                key: "rushType",
                align: "center",
                render: (rushType, record) => <>{parseFloat(record.rush_vendor_percent).toFixed(0) + "%"}</>,
            },
            {
                title: "Vendor Price",
                dataIndex: "total_to_pay_value",
                key: "vendorPrice",
                align: "right",
                render: (price, record) => (
                    <>
                        {price} {record.total_to_pay_type}
                    </>
                ),
            },
        ];

        return __columns;
    };

    return (
        <>
            <Table
                size="small"
                className="components-table-demo-nested"
                columns={columns(props)}
                expandable={{
                    expandedRowRender,
                    rowExpandable: (record) => record.catlog,
                }}
                rowKey={(record) => record.id}
                dataSource={props.tasks}
                pagination={false}
            />
        </>
    );
};

export default Tasks;
